module.exports = __webpack_public_path__ + "static/media/LoaderWhite.193e8bf2.svg";